class RulesJson {
  assetType: string;
  anchors: Record<string, any>;
  rules: any[];

  constructor(assetType: string = '', anchors: Record<string, any> = {}, rules: any[] = []) {
    this.assetType = assetType;
    this.anchors = anchors;
    this.rules = rules;
  }
}

const operatorMapping: Record<string, string> = {
  '==': '=',
  '!=': '!=',
  '<': '<',
  '<=': '<=',
  '>': '>',
  '>=': '>=',
  'is': '='
};

const logicalOperatorMapping: Record<string, boolean> = {
  AND: true,
  OR: true,
};

const specialKeys: Record<string, boolean> = {
  prerequisite: true,
  trigger_pre: true,
  trigger_post: true,
  email_condition: true,
};

function processCondition(value: any) {
  const s = value.value.split('.');
  const regex = /^(\S+?)(_\d{1,2})?\s*$/;
  const match = s[0].match(regex);
  let seq = 0;

  if (match?.[2]) {
    seq = parseInt(match[2].substring(1));
    s[0] = match[1];
  }

  if (s[2]) {
    s[1] = `${s[1]}.${s[2]}`;
  }

  const operands = s[1].split(' ');
  const triState = ['False', 'True', 'None'];

  let type = 'string';
  let opValue = operands[2].replace(/"/g, '');
  let input = 'string';
  let operator = operatorMapping[operands[1]];

  if (!isNaN(+operands[2])) {
    input = 'number';
    type = 'double';
    opValue = Number(operands[2]);
  } else if (triState.includes(operands[2])) {
    type = 'string';
    input = 'select';
    operator = 'equal';
    opValue = triState[2];
  }

  let valueResult: any = opValue;
  if (s[0] !== '_sys_attr' && s[0] !== '_state') {
    valueResult = {
      value: opValue,
      seq: seq,
    };
  }

  if (s[0] === '_state' && operands[0] === 'in_business_hour') {
    if (valueResult === 2) {
      valueResult = 'none';
    }
  }

  return {
    id: `${s[0]} - ${operands[0]}`,
    field: `${s[0]} - ${operands[0]}`,
    input,
    type,
    operator,
    value: valueResult,
  };
}

function processConditionRecursive(anchors: Record<string, any>, value: any): any {
  let jsonRule: any = {};
  let c = 0;
  for (let i = 0; i < value.items.length; i++) {
    const key = value.items[i].key.value;
    if (logicalOperatorMapping[key]) {
      jsonRule['condition'] = key;
      jsonRule['rules'] = [];

      for (let j = 0; j < value.items[i].value.items.length; j++) {
        const item = value.items[i].value.items[j];

        if ('items' in item) {
          jsonRule['rules'][c] = processConditionRecursive(anchors, item);
          c++;
          continue;
        }

        if ('type' in item) {
          jsonRule['rules'][c] = processCondition(item.source);
          c++;
        } else {
          jsonRule['rules'][c] = anchors[item.source]?.condition;
          c++;
        }
      }
    } else if (key === 'condition') {
      return processConditionRecursive(anchors, value.items[i].value);
    }
  }
  return jsonRule;
}

function yamlToJsonNew(selectedAssetType: string, rules: any) {
  const jsonRules = new RulesJson();

  if ('anchors' in rules) {
    rules.anchors.map.forEach((anchorMap: any, anchorKey: string) => {
      console.log(`anchorName: ${anchorKey}`);
      const jsonAnchor: Record<string, any> = {};

      for (let i = 0; i < anchorMap.items.length; i++) {
        const k = anchorMap.items[i].key;
        const v = anchorMap.items[i].value;
        let opValue = v.value;

        if (k.value === 'condition') {
          opValue = processCondition(opValue);
          opValue['anchor_name'] = anchorKey;
        }
        jsonAnchor[k.value] = opValue;
      }

      jsonRules.anchors[anchorKey] = jsonAnchor;
    });

    for (let i = 0; i < rules.contents.items.length; i++) {
      const key = rules.contents.items[i].key;
      const value = rules.contents.items[i].value;

      if (key.value === '_rules' && value.items[0].key === 'Default') {
        const ruleList = value.items[0].value.items;
        if (ruleList) {
          ruleList.forEach((rule: any, k: number) => {
            const items = rule.items;
            const jsonRule: Record<string, any> = {};

            for(var l = 0; l < items.length; l++ ) {
              if (items[l].key.value in specialKeys) {
                var jr = processConditionRecursive(jsonRules.anchors, items[l].value)
                jsonRule[items[l].key.value] = jr
                continue
              }
              jsonRule[items[l].key] = items[l].value.value
            }

            jsonRules.rules[k] = jsonRule;
          });
        }
      }
    }
  } else {
    for (let i = 0; i < rules.contents.items.length; i++) {
      const key = rules.contents.items[i].key;
      const value = rules.contents.items[i].value;

      if ('anchor' in value) {
        const jsonAnchor: Record<string, any> = {};

        for (let j = 0; j < value.items.length; j++) {
          const k = value.items[j].key;
          const v = value.items[j].value;
          let opValue = v.value;

          if (k === 'condition') {
            opValue = processCondition(v);
            opValue['anchor_name'] = value.anchor;
          }
          jsonAnchor[k] = opValue;
        }
        jsonRules.anchors[value.anchor] = jsonAnchor;
      } else if (key.value == '_rules' && value.items[0].key == 'Default') {
        const ruleList = value.items[0].value.items;
        if (ruleList) {
          ruleList.forEach((rule: any, k: number) => {
            const items = rule.items;
            const jsonRule: Record<string, any> = {};

            for(var l = 0; l < items.length; l++ ) {
              if (items[l].key.value in specialKeys) {
                var jr = processConditionRecursive(jsonRules.anchors, items[l].value)
                jsonRule[items[l].key.value] = jr
                continue
              }
              jsonRule[items[l].key] = items[l].value.value
            }

            jsonRules.rules[k] = jsonRule;
          });
        }
      }
    }
  }

  jsonRules.assetType = selectedAssetType;
  return jsonRules;
}


export default yamlToJsonNew;


export const BUSINESS_HOUR_FIELD = '_state.business_hour';
export const BUSINESS_HOUR_START_FIELD = '_state.business_hour_start';
export const BUSINESS_HOUR_END_FIELD = '_state.business_hour_end';
export const DEFAULT_BUSINESS_HOUR_START = 9;
export const DEFAULT_BUSINESS_HOUR_END = 17;

export function normalizeHour(value: any, fallback: number): number {
  const hour = Number(value);
  if (!Number.isFinite(hour)) {
    return fallback;
  }
  return Math.min(23, Math.max(0, Math.trunc(hour)));
}

export function parseBusinessHourValue(value: any): { start: number; end: number } {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return {
      start: normalizeHour(value.start, DEFAULT_BUSINESS_HOUR_START),
      end: normalizeHour(value.end, DEFAULT_BUSINESS_HOUR_END),
    };
  }
  if (typeof value === 'string' && value.includes(',')) {
    const [start, end] = value.split(',');
    return {
      start: normalizeHour(start, DEFAULT_BUSINESS_HOUR_START),
      end: normalizeHour(end, DEFAULT_BUSINESS_HOUR_END),
    };
  }
  if (value !== undefined && value !== null && value !== '') {
    const hour = normalizeHour(value, DEFAULT_BUSINESS_HOUR_START);
    return { start: hour, end: DEFAULT_BUSINESS_HOUR_END };
  }
  return {
    start: DEFAULT_BUSINESS_HOUR_START,
    end: DEFAULT_BUSINESS_HOUR_END,
  };
}

function isBusinessHourUiField(field: string | undefined): boolean {
  return field === BUSINESS_HOUR_FIELD
    || field === '_state - business_hour'
    || field === BUSINESS_HOUR_START_FIELD
    || field === BUSINESS_HOUR_END_FIELD
    || field === '_state - business_hour_start'
    || field === '_state - business_hour_end';
}

function isBusinessHourStartField(field: string | undefined): boolean {
  return field === BUSINESS_HOUR_START_FIELD || field === '_state - business_hour_start';
}

function isBusinessHourEndField(field: string | undefined): boolean {
  return field === BUSINESS_HOUR_END_FIELD || field === '_state - business_hour_end';
}

const IN_BUSINESS_HOUR_FIELD = '_state.in_business_hour';

function isInBusinessHourField(field: string | undefined): boolean {
  return field === IN_BUSINESS_HOUR_FIELD || field === '_state - in_business_hour';
}

function isInBusinessHourNone(rule: any): boolean {
  if (!rule || (rule as QueryBuilderRule).combinator || !isInBusinessHourField(rule.field)) {
    return false;
  }
  const value = rule.value;
  return rule.operator === 'is'
    || value === 'None'
    || value === 'none'
    || value === 2
    || value === '2';
}

function isLegacyInBusinessHourFlag(rule: any): boolean {
  if (!rule || (rule as QueryBuilderRule).combinator || !isInBusinessHourField(rule.field)) {
    return false;
  }
  if (isInBusinessHourNone(rule)) {
    return false;
  }
  return ['==', '=', '>=', '>'].includes(rule.operator);
}

function businessHourUiRule(start?: number, end?: number): Rule {
  return {
    id: `${BUSINESS_HOUR_FIELD} - window`,
    field: BUSINESS_HOUR_FIELD,
    operator: 'between',
    sequence: 0,
    value: {
      start: normalizeHour(start, DEFAULT_BUSINESS_HOUR_START),
      end: normalizeHour(end, DEFAULT_BUSINESS_HOUR_END),
    } as any,
  };
}

interface Rule {
  id: string;
  field: string;
  operator: string;
  sequence: number;
  value: string | number | null;
}

interface QueryBuilderRule {
  // id: string;
  combinator: 'and' | 'or';
  rules: (Rule | QueryBuilderRule)[];
}

const parseRuleString = (ruleString: string): Rule | null => {
  const regex = /^([\w.]+)\s*(==|=|!=|<=|<|>=|>|is)\s*(.+)$/;
  const match = ruleString.match(regex);

  if (match) {
    let [id, field, operator, value] = match;
    const fieldRegex = /_(\d+)\./;
    const fieldMatch = field.match(fieldRegex);
    let sequence = 0;
    if (fieldMatch) {
      console.log("NEW Seq field match: ", fieldMatch)
      sequence = Number(fieldMatch[1]);

      const dotIndex = field.indexOf('.');
      field = field.substring(0, dotIndex).replace(/(_\d+)$/, '') + '.' + field.substring(dotIndex + 1)
      field = field + ':seq=' + fieldMatch[1];
    }

    // const valueRegex = /^[a-zA-Z0-9_]+\.[a-zA-Z0-9_.]+(\s*([\+\-\*\/]?\s*\d+(\.\d+)?))?$/;
    const valueRegex = /^(?=.*[a-zA-Z_])[a-zA-Z0-9_]+\.[a-zA-Z0-9_.]+(\s*([\+\-\*\/]?\s*\d+(\.\d+)?))?$/;
    let isFieldToField = valueRegex.test(value) && !/^\d+\.\d+$/.test(value.split(/\s+/)[0]);
    if (typeof value === 'string' && value.startsWith('_parameter.')) {
      // HANDLE parameter type value
      let dupValue = value;
      
      dupValue = dupValue.replace("_parameter.", "");
      if (sequence > 0) {
        const dotIndex = dupValue.indexOf('.');
        let component = dupValue.substring(0, dotIndex)
        component = component.replace(/(_\d+)$/, '');
        
        dupValue = component + '.' + dupValue.substring(dotIndex + 1)
      }
      value = '_parameter.' + dupValue
      console.log("NEW _parameter RULE: ", field, value)
    } else if (isFieldToField) {
      if (sequence > 0) {
        const dotIndex = value.indexOf('.');
        let component = value.substring(0, dotIndex)
        component = component.replace(/(_\d+)$/, '');
        
        value = component + '.' + value.substring(dotIndex + 1)
      }
      console.log("field-to-field Value: ", value)
      value = '$' + value
    }
    return {
      id: `${id} - ${field}`,
      field: field.trim(),
      operator: operatorMapping[operator.trim()] || operator.trim(),
      sequence: sequence,
      value: value === 'None' ? 'None' : !isNaN(Number(value)) ? Number(value) : value.replace(/^"(.*)"$/, '$1').trim(),
    };
  }

  return null;
};

export function convertToQueryBuilderFormat(data: any): QueryBuilderRule {
  const root: QueryBuilderRule = {
    combinator: data.condition.toLowerCase() as 'and' | 'or',
    rules: [],
  };

  data.rules.forEach((rule: any) => {
    if (typeof rule === 'string') {
      const parsedRule = parseRuleString(rule);
      if (parsedRule) {
        root.rules.push(parsedRule);
      }
    } else if (rule.condition) {
      root.rules.push(convertToQueryBuilderFormat(rule));
    }
  });

  return root;
};

export function formatRules(ruleGroup: any): any | null {
  // Check all rules (including nested ones) for empty string values
  const hasEmptyStringValue = ruleGroup.rules.some((rule: any) => {
    if (rule.rules) {
      return false;
    } else {
      if (typeof rule.value === 'string') {
        if (rule.value.trim() === '' || rule.value.trim() === '$') {
          return true;
        } 
        else {
          if (rule.value.trim().startsWith('$')) {
            let value = rule.value.replace('$', '').trim();
            const valueRegex = /^[a-zA-Z0-9_]+\.[a-zA-Z0-9_.]+(\s*([\+\-\*\/]?\s*\d+(\.\d+)?))?$/;
            let isValidValue = valueRegex.test(value) && !/^\d+\.\d+$/.test(value.split(/\s+/)[0]);
            return !isValidValue;
          }
        }
      }

      return false
    }
  });

  if (hasEmptyStringValue) {
    return null;
  }

  // Process the rules
  const formattedRules = ruleGroup.rules.map((rule: any) => {
    if (rule.rules) {
      // Handle nested rules recursively
      const nestedResult = formatRules(rule);
      return nestedResult;
    } else {
      // Format individual rule
      let field = rule.field;
      const value = rule.value;
      const regex = /^(.*?)\.(.+?):seq=(\d+)$/;
      const match = field.match(regex);
  
      if (match) {
        const [, prefix, suffix, seqNum] = match;
        console.log("Seq Num match: ", match);
        if (seqNum == "0") {
          field = `${prefix}.${suffix}`;
        } else {
          field = `${prefix}_${seqNum}.${suffix}`;
        }
      }
      
      return `${field} ${rule.operator} ${value}`;
    }
  });

  // Check if any nested rule returned null
  if (formattedRules.some(rule => rule === null)) {
    return null;
  }

  return {
    condition: ruleGroup.combinator.toUpperCase(),
    rules: formattedRules
  };
}

function businessHourBound(rule: any, fieldCheck: (field: string | undefined) => boolean, operators: string[]): number | undefined {
  if (!rule || (rule as QueryBuilderRule).combinator || !fieldCheck(rule.field)) {
    return undefined;
  }
  if (!operators.includes(rule.operator)) {
    return undefined;
  }
  const hour = Number(rule.value);
  return Number.isFinite(hour) ? hour : undefined;
}

export function collapseBusinessHourWindow(group: QueryBuilderRule): QueryBuilderRule {
  const collapsedRules: (Rule | QueryBuilderRule)[] = [];
  let start: number | undefined;
  let end: number | undefined;

  group.rules.forEach((rule) => {
    if ((rule as QueryBuilderRule).combinator && (rule as QueryBuilderRule).rules) {
      const nested = collapseBusinessHourWindow(rule as QueryBuilderRule);
      collapsedRules.push(unwrapSingleBusinessHourGroup(nested));
      return;
    }

    const startHour = businessHourBound(rule, isBusinessHourStartField, ['>=', '>']);
    const endHour = businessHourBound(rule, isBusinessHourEndField, ['<=', '<']);
    if (startHour !== undefined) {
      start = (rule as Rule).operator === '>' ? Math.min(23, startHour + 1) : startHour;
      return;
    }
    if (endHour !== undefined) {
      end = (rule as Rule).operator === '<' ? Math.max(0, endHour - 1) : endHour;
      return;
    }
    collapsedRules.push(rule);
  });

  const hasWindow = start !== undefined || end !== undefined;
  const hasLegacyFlag = collapsedRules.some((rule) => isLegacyInBusinessHourFlag(rule));
  const hasUiWindow = collapsedRules.some((rule) =>
    isBusinessHourUiField((rule as Rule).field) && !(rule as QueryBuilderRule).combinator
  );

  let rules = collapsedRules;
  if (hasWindow) {
    rules = collapsedRules.filter((rule) => !isLegacyInBusinessHourFlag(rule));
    rules.push(businessHourUiRule(start, end));
  } else if (hasUiWindow && hasLegacyFlag) {
    rules = collapsedRules.filter((rule) => !isLegacyInBusinessHourFlag(rule));
  } else if (hasLegacyFlag) {
    rules = collapsedRules.filter((rule) => !isLegacyInBusinessHourFlag(rule));
    rules.push(businessHourUiRule());
  }

  return {
    combinator: group.combinator,
    rules,
  };
}

function unwrapSingleBusinessHourGroup(group: QueryBuilderRule): Rule | QueryBuilderRule {
  if (group.rules.length !== 1) {
    return group;
  }

  const only = group.rules[0] as Rule;
  if (only && isBusinessHourUiField(only.field) && !(only as any).combinator) {
    return only;
  }

  return group;
}

export function expandEmailBusinessHours(ruleGroup: any): any {
  if (!ruleGroup?.rules) {
    return ruleGroup;
  }

  const rules: any[] = [];
  ruleGroup.rules.forEach((rule: any) => {
    if (rule.rules) {
      rules.push(expandEmailBusinessHours(rule));
      return;
    }

    if (rule.field === BUSINESS_HOUR_FIELD || rule.field === '_state - business_hour') {
      const { start, end } = parseBusinessHourValue(rule.value);
      const inBusinessHourRule = {
        field: IN_BUSINESS_HOUR_FIELD,
        operator: '==',
        value: 1,
      };
      const startRule = {
        field: BUSINESS_HOUR_START_FIELD,
        operator: '>=',
        value: start,
      };
      const endRule = {
        field: BUSINESS_HOUR_END_FIELD,
        operator: '<=',
        value: end,
      };

      const windowRules = start > end
        ? [inBusinessHourRule, { combinator: 'or', rules: [startRule, endRule] }]
        : [inBusinessHourRule, startRule, endRule];

      if ((ruleGroup.combinator || 'and').toLowerCase() === 'and') {
        rules.push(...windowRules);
      } else {
        rules.push({ combinator: 'and', rules: windowRules });
      }
      return;
    }

    rules.push(rule);
  });

  return {
    ...ruleGroup,
    rules,
  };
}